import { Sprite } from '@pixi/sprite';
import { Ticker } from '@pixi/ticker';

import { Shared } from '../../App';
import { NineSliceButton, NineSliceButtonOpts } from './NineSliceButton';

export class ShopButton extends NineSliceButton
{
    protected animating: boolean;

    constructor(opts: Partial<NineSliceButtonOpts> = {})
    {
        const icon = Sprite.from(Shared.assets.getTexture('icon-shop'));

        super({
            icon,
            bgAsset: 'button-ninesliced-yellow',
            w: icon.width * 1.5,
            h: icon.height * 1.5,
            ...opts,
        });

        this.animating = false;
        this.startAnimating();
    }

    public startAnimating(): void
    {
        if (this.animating) return;
        this.animating = true;
        Ticker.system.add(this.updateAnimation, this);
    }

    public stopAnimating(): void
    {
        if (!this.animating) return;
        this.animating = false;
        Ticker.system.remove(this.updateAnimation, this);
    }

    protected updateAnimation(): void
    {
        if (!this.animating || !this.view.visible || !this.view.renderable) return;
        this.icon.y = Math.min(Math.sin(Ticker.system.lastTime * 0.01) * 8, 0);
    }
}
